import { ReactElement } from 'react'
import useElementLabelDescriptors from '../ModelElementLabels/useElementLabelDescriptors'
import BatchedElementLabels from './BatchedElementLabels'

/**
 * Renders all element labels in the 3D view in two draw calls instead of a
 * handful of meshes per label. The floorplan view has its own labels - see
 * `FloorplanModelLabels`.
 */
const ModelElementLabelsV2 = (): ReactElement => {
  const descriptors = useElementLabelDescriptors()

  return <BatchedElementLabels descriptors={descriptors} />
}

export default ModelElementLabelsV2
